import gql from 'fraql'
export const fragments = {
  clientFields: gql`
    fragment _ on Client {
      id
      name
      discount
      comment
      phone
      onlyOnlinePayment
      brand: brandByIdBrand {
        id
        name
      },
      lastAddresses {
        nodes {
          street
          house
          entrance
          apartment
          floor
          office
        }
      }
    }
  `
}

export default {
  FIND_CLIENT: gql`
  query findClient ($idBrand: Int!, $phone: String!) {
    findClient(idBrand: $idBrand, phone: $phone) {
      ${fragments.clientFields}
    }
  }`,
  UPDATE_COMMENT: gql`
  mutation UpdateClientComment ($clientId: Int!, $comment: String!) {
    updateClientById(input:{id: $clientId, clientPatch: {comment: $comment}}) {
      clientMutationId
    }
  }`,
  CREATE_PROFILE: gql`
  mutation CreateClient ($idBrand: Int!, $name: String!, $phone: String!) {
   createClient(input: {client: {idBrand: $idBrand, name: $name, phone: $phone}}) {
      client {
        ${fragments.clientFields}
      }
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/clientQueries.js